import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const LogoutIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M13.3333 5.83333L17.5 10L13.3333 14.1667M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
